export const desktopApiKeyFlag = "sumatra-online-desktop-apikey";

export function desktopFlagFresh(flag: string): boolean {
  if (flag === "1") return true;
  const t = Number(flag);
  return Number.isFinite(t) && Date.now() - t < 60 * 60 * 1000;
}
